import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import Durable from './icons/Durable';
import Installation from './icons/Installation';
import App from './icons/App';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterL: any = null,
    sceneTextLeaveL: any = null;
export default function L({ callTab }: any) {
    const { useLang, useRouter, useEffect, useState, gtmm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    const items: any[] = [
        {
            icon: <Durable />,
            title: t('secL_item1_title'),
            desc: t('secL_item1_desc'),
        },
        {
            icon: <Installation />,
            title: t('secL_item2_title'),
            desc: t('secL_item2_desc'),
            link: t('secL_item2_link'),
        },
        {
            icon: <App />,
            title: t('secL_item3_title'),
            desc: t('secL_item3_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterL) {
                    AniContainer.removeScene(sceneTextEnterL);
                    sceneTextEnterL = null;
                }
                if (sceneTextLeaveL) {
                    AniContainer.removeScene(sceneTextLeaveL);
                    sceneTextLeaveL = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterL = AniContainer.create({
                    triggerElement: '.shp2-detail-L .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterL) {
                    AniContainer.removeScene(sceneTextEnterL);
                    sceneTextEnterL = null;
                }
                if (sceneTextLeaveL) {
                    AniContainer.removeScene(sceneTextLeaveL);
                    sceneTextLeaveL = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-L shp2-detail-section ${css['shp2-detail-L']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secL_subtitle')}</p>
                <h2 className="title">{t('secL_title')}</h2>
                <p className="desc">{t('secL_desc')}</p>
            </div>
            <div className="card">
                <div className="card-img">
                    <EFPicture
                        src="/responsive/picture/smart-home-panel-2/launch/12.jpg"
                        srcPad="/responsive/picture/smart-home-panel-2/launch/12_768.jpg"
                        srcMobile="/responsive/picture/smart-home-panel-2/launch/12_768.jpg"
                        alt={t('secL_title')}
                    />
                </div>
                <ul className="card-features">
                    {items?.map((item: any, k: number) => (
                        <li className="item" key={k}>
                            <div className="item-icon">{item?.icon}</div>
                            <p className="item-title">{item?.title}</p>
                            <p className="item-desc">{item?.desc}</p>
                            {item?.link && (
                                <button className="item-link" onClick={() => callTab({ tab: 'support', active: 'tutorial' })}>
                                    <span className="link-text">{item?.link}</span>
                                    <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.25602 2.35889L11.5894 7.69222L6.25602 13.0256"
                                            stroke="#3F68E0"
                                            strokeWidth="1.4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
